import AddChannelMenu from 'components/admin/add_channel_menu';
import connect from 'components/lib/connect';
import Endpoint from 'models/endpoint';
import LoginToFb from 'actions/channels/login_to_fb';
import AuthorizeTwitter from 'actions/channels/authorize_twitter';
import PropTypes from 'prop-types';

function mapExecuteToProps(executeAction) {
  return {
    loginToFb() {
      executeAction(LoginToFb);
    },
    authorizeTwitter() {
      executeAction(AuthorizeTwitter);
    },
  };
}

function mapStateToProps({ getProvider, isFeatureEnabled }) {
  let hasTwitterEndpoint = false;
  const isInstagramMessagingEnabled = isFeatureEnabled('enableInstagramMessaging');
  const channelConfiguration = getProvider('channelConfiguration').get() || {};
  const messageConfiguration = getProvider('messagingConfiguration').get() || {};
  const multipleTwitterChannels = messageConfiguration.multipleTwitterChannels;
  let endpoints = channelConfiguration.endpoints || [];
  for (let endpoint of endpoints) {
    if (endpoint.type === Endpoint.Type.TWITTER) {
      hasTwitterEndpoint = true;
      break;
    }
  }
  return { hasTwitterEndpoint, multipleTwitterChannels, isInstagramMessagingEnabled };
}

const AddChannelMenuContainer = connect(mapStateToProps, mapExecuteToProps)(AddChannelMenu);

AddChannelMenuContainer.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
};

export default AddChannelMenuContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/add_channel_menu_container.jsx